import {
	GET_POSITIONS, GET_POSITIONS_SUCCESS, GET_POSITIONS_FAIL,
	GET_POSITIONS_DETAILS, GET_POSITIONS_DETAILS_SUCCESS, GET_POSITIONS_DETAILS_FAIL,
	POSITION_CREATE,POSITION_CREATE_FAIL,POSITION_CREATE_SUCCESS,
	POSITION_CREATE_JOB, POSITION_CREATE_JOB_SUCCESS, POSITION_CREATE_JOB_FAIL,
	POSITION_DELETE,POSITION_DELETE_FAIL,POSITION_DELETE_SUCCESS,
	POSITION_UPDATE,POSITION_UPDATE_FAIL,POSITION_UPDATE_SUCCESS,RESET, GET_POSITIONS_SETTING_FAIL, GET_POSITIONS_SETTING_SUCCESS, SAVE_POSITIONS_SETTING_FAIL, SAVE_POSITIONS_SETTING_SUCCESS, SAVE_POSITIONS_SETTING, GET_POSITIONS_SETTING, POSITION_COPY, POSITION_COPY_SUCCESS, POSITION_COPY_FAIL, POSITION_STATUS_CREATE, POSITION_STATUS_CREATE_SUCCESS, POSITION_STATUS_CREATE_FAIL, POSITION_STATUS_UPDATE, POSITION_STATUS_UPDATE_SUCCESS, POSITION_STATUS_UPDATE_FAIL, POSITION_STATUS_DELETE, POSITION_STATUS_DELETE_SUCCESS, POSITION_STATUS_DELETE_FAIL, GET_LOOKUP_POSITIONS, GET_LOOKUP_POSITIONS_SUCCESS, GET_LOOKUP_POSITIONS_FAIL
  ,  GET_JOB_POSITIONS,
  GET_JOB_POSITIONS_SUCCESS,
  GET_JOB_POSITIONS_FAIL,
  JOB_POSITION_CREATE,
  JOB_POSITION_CREATE_SUCCESS,
  JOB_POSITION_CREATE_FAIL,
  JOB_POSITION_UPDATE,
  JOB_POSITION_UPDATE_SUCCESS,
  JOB_POSITION_UPDATE_FAIL,
  JOB_POSITION_DELETE,
  JOB_POSITION_DELETE_SUCCESS,
  JOB_POSITION_DELETE_FAIL

} from "./actionTypes";

  export const getPositions = (payload) => {
	return {
	  type: GET_POSITIONS,
	  payload: payload
	};
  };
  
  export const getPositionsSuccess = (posts) => {
	return {
	  type: GET_POSITIONS_SUCCESS,
	  payload: posts,
	};
  };
  
  export const getPositionsFail = (error) => {
	return {
	  type: GET_POSITIONS_FAIL,
	  payload: error,
	};
  };

  export const getLookupPositions = () => {
	return {
	  type: GET_LOOKUP_POSITIONS
	};
  };
  
  export const getLookupPositionsSuccess = (posts) => {
	return {
	  type: GET_LOOKUP_POSITIONS_SUCCESS,
	  payload: posts,
	};
  };
  
  export const getLookupPositionsFail = (error) => {
	return {
	  type: GET_LOOKUP_POSITIONS_FAIL,
	  payload: error,
	};
  };
  
  export const getPositionsDetails = (id) => {
	return {
	  type: GET_POSITIONS_DETAILS,
	  payload: id,
	};
  };
  
  export const getPositionsDetailsSuccess = (post) => {
	return {
	  type: GET_POSITIONS_DETAILS_SUCCESS,
	  payload: post,
	};
  };
  
  export const getPositionsDetailsFail = (error) => {
	return {
	  type: GET_POSITIONS_DETAILS_FAIL,
	  payload: error,
	};
  };

  export const createPosition =(payload)=>{
	return {
		type: POSITION_CREATE,
		payload: payload
	}
  }
  export const createPositionSuccess =(response)=>{
	return {
		type: POSITION_CREATE_SUCCESS,
		payload: response
	}
  }
  export const createPositionFail =(error)=>{
	return {
		type: POSITION_CREATE_FAIL,
		payload: error
	}
  }

  export const createPositionJob = (payload) => {
  return {
    type: POSITION_CREATE_JOB,
    payload: payload,
  };
};

export const createPositionJobSuccess = (response) => {
  return {
    type: POSITION_CREATE_JOB_SUCCESS,
    payload: response,
  };
};

export const createPositionJobFail = (error) => {
  return {
    type: POSITION_CREATE_JOB_FAIL,
    payload: error,
  };
};


  export const updatePosition =(payload)=>{
	
	return {
		type: POSITION_UPDATE,
		payload: payload
	}
  }
  export const updatePositionSuccess =(response)=>{
	return {
		type: POSITION_UPDATE_SUCCESS,
		payload: response
	}
  }
  export const updatePositionFail =(error)=>{
	return {
		type: POSITION_UPDATE_FAIL,
		payload: error
	}
  }


  export const deletePosition =(payload)=>{
	return {
		type: POSITION_DELETE,
		payload: payload
	}
  }
  export const deletePositionSuccess =(response)=>{
	return {
		type: POSITION_DELETE_SUCCESS,
		payload: response
	}
  }
  export const deletePositionFail =(error)=>{
	return {
		type: POSITION_DELETE_FAIL,
		payload: error
	}
  }
// GET
export const getJobPositions = (id) => {
  return {
    type: GET_JOB_POSITIONS,
    payload: id,
  };
};

export const getJobPositionsSuccess = (post) => {
  return {
    type: GET_JOB_POSITIONS_SUCCESS,
    payload: post,
  };
};

export const getJobPositionsFail = (error) => {
  return {
    type: GET_JOB_POSITIONS_FAIL,
    payload: error,
  };
};

// CREATE
export const createJobPosition = (payload) => {
  return {
    type: JOB_POSITION_CREATE,
    payload,
  };
};

export const createJobPositionSuccess = (response) => {
  return {
    type: JOB_POSITION_CREATE_SUCCESS,
    payload: response,
  };
};

export const createJobPositionFail = (error) => {
  return {
    type: JOB_POSITION_CREATE_FAIL,
    payload: error,
  };
};

// UPDATE
export const updateJobPosition = (payload) => {
  return {
    type: JOB_POSITION_UPDATE,
    payload,
  };
};

export const updateJobPositionSuccess = (response) => {
  return {
    type: JOB_POSITION_UPDATE_SUCCESS,
    payload: response,
  };
};

export const updateJobPositionFail = (error) => {
  return {
    type: JOB_POSITION_UPDATE_FAIL,
    payload: error,
  };
};

// DELETE
export const deleteJobPosition = (payload) => {
  return {
    type: JOB_POSITION_DELETE,
    payload,
  };
};

export const deleteJobPositionSuccess = (response) => {
  return {
    type: JOB_POSITION_DELETE_SUCCESS,
    payload: response,
  };
};

export const deleteJobPositionFail = (error) => {
  return {
    type: JOB_POSITION_DELETE_FAIL,
    payload: error,
  };
};
  export const reset=()=>{
	return {
		type:RESET,
	}
  }

